import withRouter from '@utils/wrappers/WithRouter';
import { Grid } from '@ts/storybook';
const _ = require('lodash');
const PropTypes = require('prop-types');
const React = require('react');
const createReactClass = require('create-react-class');
const Immutable = require('immutable');
const { Loading } = require('@components/Misc');
const act = require('@flux/actions/actView');
const Mixin = require('@utils/mixin/mixin');
const DataTable = require('@modules/DataTable').default;
const Link = require('@components/Outputs/Link').default;
const h = require('@utils/helpers');
const App = require('@gral/app');
const { withTranslation } = require('react-i18next');

const ContactDataTable = createReactClass({
  displayName: 'ContactDatasTable',
  mixins: [Mixin.Base, Mixin.Needs],
  propTypes: {
    app: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    contactDatas: PropTypes.object.isRequired,
  },

  getDefaultProps() {
    return {
      title: 'Settings',
      editUrl: '/contactData',
      editDataPath: 'editContactData',
      baseFilter: {},
      initSortAttr: 'id',
      fInitReverseSort: false,
      fAllowQuickSearch: true,
      fAllowEdit: true,
      fAllowCreate: true,
      extraFABs: [],
    };
  },

  getInitialState() {
    return { filter: this.props.transferPropsRoute.query };
  },

  render() {
    this._contactDatas = this.props.contactDatas;
    if (!this._contactDatas) {
      return <Loading />;
    }
    this._items = this._contactDatas;
    return this._renderData();
  },

  _filterData(items) {
    const filter = _.extend({}, this.props.baseFilter, this.state.filter);
    const outItems = items;
    const filterDescs = [];

    return { items: outItems, filterDescs };
  },

  _renderData() {
    return (
      <DataTable
        title={this.props.title}
        editUrl={this.props.editUrl}
        editDataPath={this.props.editDataPath}
        fnChange={this.props.fnChange}
        fnFilter={filter => this.setState({ filter })}
        fFiltered={_.size(this.state.filter) > 0}
        fnFilterData={this._filterData}
        fPortal={this.props.fPortal}
        pkColumn="id"
        initSortAttr={this.props.initSortAttr}
        fAllowQuickSearch={this.props.fAllowQuickSearch}
        fAllowEdit={this.props.fAllowEdit}
        fAllowCreate={this.props.fAllowCreate}
        defaultCreationProperties={this.props.defaultCreationProperties}
        columns={this._getColumns()}
        rows={this._items}
        extraFABs={this.props.extraFABs}
        entity="taUser"
      />
    );
  },

  _getColumns() {
    const cols = [
      {
        fnLabel: () => {
          return this.props.t('ID');
        },
        name: 'id',
        fHidden: true,
      },
      {
        fnLabel: () => {
          return this.props.t('Name');
        },
        name: 'name',
        rawValue(o) {
          return o.get('name');
        },
        filterValue(o) {
          return o.get('name');
        },
        sortValue(o) {
          return o.get('name');
        },
        render: (o, value) => {
          let elId;
          const id = o.get('logicalId');
          if (this.props.fPortal) {
            elId = <span style={_style.name}>{value}</span>;
          } else {
            elId = <Link href={`/contactData/${id}/view`}>{value}</Link>;
          }
          return <span>{elId}</span>;
        },
      },
      {
        fnLabel: () => {
          return this.props.t('Value');
        },
        name: 'data',
        rawValue(o) {
          return o.get('data');
        },
        render: (o, value) => value,
      },
      {
        fnLabel: () => {
          return this.props.t('Type');
        },
        name: 'contactDataTypeLogicalId',
        rawValue(o) {
          return o.get('ContactDataType');
        },
        render: (o, value) => value.get('name'),
      },
    ];
    if (this.props.actions) {
      cols.push({
        fnLabel: () => {
          return this.props.t('Actions');
        },
        name: 'action',
        rawValue(o) {
          return o.get('id');
        },
        render: (o, name) => {
          let r;
          const id = o.get('id');
          return (r = this.props.actions.map(action => {
            let disabled = false;
            if (this.props.entity) {
              if (!App.cxStore.checkPermission(this.props.entity, 'edit') || action.fDisabled) {
                disabled = true;
              }
            } else if (action.fDisabled) {
              disabled = true;
            }

            return;
          }));
        },
      });
    }
    return cols;
  },
});
export default withRouter(withTranslation()(ContactDataTable));

const _style = { outer: {} };
